import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import styles from './menuToggler.css';

const pageStyles = {
  Works: 'fillRed',
  Home: 'fillBlack',
  Agency: 'fillRed',
  Reels: 'fillRedImportant',
  NotFound: 'fillWhite',
};

const MenuToggler = ({
  onClick, isOpen, page, color,
}) => (
  <button
    title="Toggle menu"
    className={cx(
      styles.menuToggler,

      isOpen ? styles.open : styles[pageStyles[page]],
    )}
    onClick={onClick}
  >
    <div className={styles.patties}>
      {Array(4)
        .fill('')
        .map((patty, i) => (
          <span
            style={{
              background: color,
            }}
            className={styles.patty}
            key={i}
            {...patty}
          />
        ))}
    </div>
  </button>
);

MenuToggler.defaultProps = {
  color: null,
};

MenuToggler.propTypes = {
  onClick: T.func.isRequired,
  isOpen: T.bool.isRequired,
  page: T.string.isRequired,
  color: T.string,
};

export default MenuToggler;



// WEBPACK FOOTER //
// ./src/components/modules/Header/MenuToggler.js